import styled from '@emotion/styled';
import type { StoreBannerTheme } from './types';

export const Container = styled.div<{ bgImage: string; isMobile: boolean }>`
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  overflow: hidden;
  min-height: 200px;
  cursor: pointer;
  ${(props) =>
    props.isMobile &&
    `
    text-align: center;
     justify-content: center;
    `}
`;

export const ContentContainer = styled.div<{ isMobile: boolean }>`
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding-top: 14px;
  ${(props) =>
    props.isMobile &&
    `
     justify-content: center;
    padding-top: 0px;
    align-items: center;
    text-align: center;
    `}
`;

export const Title = styled.div<{ bannerTheme: StoreBannerTheme }>`
  max-width: 700px;
  font-weight: 700;
  font-size: 24px;
  color: ${(props) => props.theme.color.blue.darkerBlue};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
`;
